import axios from 'axios';

const api = axios.create({
  // baseURL: "http://staging.agrobrazilapp.com/",
  baseURL: 'https://agrobrazilapp.com/',
});

api.interceptors.request.use(
  (config) => {
    if (sessionStorage.getItem('email') && sessionStorage.getItem('token')) {
      config.headers.common.USER_EMAIL = sessionStorage.getItem('email');
      config.headers.common.USER_TOKEN = sessionStorage.getItem('token');
      config.headers.common['Cache-Control'] = 'no-cache';
    }
    return config;
  },
);

export default api;
